module.exports = __webpack_public_path__ + "img/symbol_hashred.2ec47e5f.png";